import { ISubMenuItem } from '@models/IHeader';
import updateDataLayer from '@utils/helpers/gtm';
import classNames from 'classnames';
import LinksList from './LinksList';
import NavigationCard from './NavigationCard';

interface Props {
  readonly activeTab?: ISubMenuItem;
  readonly hasAnimatedNavCardName?: boolean;
  readonly mainCategory: string;
  readonly subCategory: string;
  readonly dataTestId?: string;
}

const HeaderSubNavTab = ({
  activeTab,
  hasAnimatedNavCardName,
  mainCategory,
  subCategory,
  dataTestId,
}: Props) => {
  const hasNavigationCards = !!activeTab?.navigationCards?.length;

  const handleLevelThreeItemClick = (itemName: string) => {
    updateDataLayer({
      event: 'menuUsed',
      content_type: 'header_menu_level_3',
      main_category: mainCategory,
      sub_category: subCategory,
      tertiary_category: itemName,
    });
  };

  return (
    <div
      className="mr-4 ml-4 flex min-h-[418px] cursor-default flex-col pb-24 lgm:mr-0 lgm:ml-0 lgm:flex-row lgm:pl-[9.5rem] xl:absolute xl:top-[100%] xl:right-0 xl:left-0 xl:bg-grey-200"
      data-testid={dataTestId}
    >
      {hasNavigationCards && (
        <div className="grid grid-flow-row auto-rows-max md:grid-cols-2 md:gap-x-8 lgm:w-8/12 xl:grid-cols-3 2xl:grid-cols-4 2xl:gap-5">
          {activeTab.navigationCards.map(({ image, link }, index) => (
            <NavigationCard
              key={`level-3-card-${link?.name}`}
              image={image}
              link={link}
              onClick={handleLevelThreeItemClick}
              dataTestId={`CT-01-Header-Sub-Nav-Tab-Navigation-Card-${index}`}
              hasAnimatedName={hasAnimatedNavCardName}
            />
          ))}
        </div>
      )}

      {!!activeTab?.links?.length && (
        <div
          className={classNames(
            'relative flex h-full justify-start lgm:w-4/12',
            {
              'lgm:justify-center': hasNavigationCards,
            }
          )}
        >
          <LinksList
            links={activeTab.links}
            onClick={handleLevelThreeItemClick}
            dataTestId="CT-01-Header-Sub-Nav-Tab-Links-List"
          />
        </div>
      )}
    </div>
  );
};

export default HeaderSubNavTab;
